module.exports = __webpack_public_path__ + "static/image/history/m/202312@x3.jpg?39c20519";